import { Component, OnInit } from '@angular/core';
import { DacConfig } from '../shared/services/dac-config.service';

@Component({
  selector: 'dac-help',
  templateUrl: './help.component.html',
  styleUrls: ['./help.component.scss']
})
export class HelpComponent implements OnInit {

  constructor(private dacConfig:DacConfig) { }

  ngOnInit() {
  }

  get supportEmail() {
    return this.dacConfig.supportEmail;
  }

  get supportPhone() {
    return this.dacConfig.supportPhone;
  }

  get copyrightTitle() {
    return this.dacConfig.copyrightTitle;
  }

  get mailLink() {
    return "mailto:" + this.supportEmail;
  }
  get phoneLink() {
    return "tel:" + this.supportPhone;
  }
  get copyrightURL() {
    return this.dacConfig.copyrightURL;
  }
}



// WEBPACK FOOTER //
// ./src/app/help/help.component.ts